export const chainguardOidcSteps = [
  {
    title: "Create an assumable identity",
    items: [
      {
        kind: "markdown",
        content:
          "Run this with [`chainctl`](https://edu.chainguard.dev/platform/chainctl/), swapping `viewer` for the role your automation needs:\n\n```\nchainctl iam identities create 3b \\\n  --identity-issuer={OIDC_PROVIDER_URL} \\\n  --subject=connected-app:{CONNECTED_APP_ID} \\\n  --audience=connected-app:{CONNECTED_APP_ID} \\\n  --role=viewer --output=id\n```\n\nCreate it under your root organization — an identity scoped to a subgroup can’t see the organization’s registry.",
      },
    ],
  },
  {
    title: "Enter the identity",
    items: [
      {
        kind: "input",
        label: "Identity UIDP",
        placeholder:
          "c95870ebffa72a258df087ea727ee92daf177e29/f067a9080d45a098",
        required: true,
        target: { kind: "configuration", field: "identityUid" },
        helperText: "The ID the command above prints.",
      },
    ],
  },
] as const;
